import React, { Component } from 'react';
import _ from 'lodash';
import {
  Button,
  Card,
  CardImg,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip
} from 'reactstrap';
import Select from 'react-select/async';
import DropZone from 'react-dropzone';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import Services from './services';
import { ProgressButton } from '../../../commons/ProgressButton';
import Mezo from './Mezo';
import Loader from '../../../commons/loader';
import { ImageCard } from '../../../commons/controls';
import SwitchButton from '../../../commons/SwitchButton';
import RFField from '../../../components/Form/RFField';
import RFForm from '../../../components/Form/RFForm';
import SelectField from '../../../components/Form/SelectField';
import Wysiwyg from '../../../components/Wysiwyg/Wysiwyg';
import ToolbarBase from '../../../components/Wysiwyg/toolbar/ToolbarBase';
import { parseEditorImage } from '../../../commons/utils';

class HelyszinUrlap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      angolNyelv: false,
      // TRUE - magyar, FALSE - angol
      magyarSwitchButton: true,
      mentesButtonLoading: false,
      toggleNested: false,
      mezoJson: {},
      orszagValue: {},
      leiras: '',
      leirasAngol: '',
      telepulesSelect: true,
      telepulesMezoInaktiv: true,
      telepulesMezo: [],
      loading: false,
      formProfil: null,
      formLogo: null,
      formGaleria: [],
      allapotok: [],
      tipusok: [],

      formOrszag: '',
      formKereses: '',
      kozterulet: '',
      kozteruletjelleg: '',
      hazszam: '',
      hrsz: '',
      lepcsohaz: '',
      epulet: '',
      emelet: '',
      ajto: '',
      postafiok: '',
      cimSwitchActive: true,
      id: null,
      cim: '',

      allapotValue: '',
      tipusValue: '',
      funkcioid: null,
      deletedImages: [],
    };
  }

  componentDidMount() {
    this.getData();
  }

  getTelepelusek = (irszam, callback) => {
    Services.listTelepules(irszam, (err, res) => {
      if (!err) {
        callback(res[0]);
      }
    });
  }

  getData = () => {
    this.setState({ loading: true });
    let params = new URL(window.location.href).searchParams;
    let id = params.get('id');
    Services.initHelyszinForm(id || undefined, (err, res) => {
      if (!err) {
        if (this.props.modositas && id && res[0].helyszin) {
          if (res[0].helyszin.kozpont !== null && !res[0].helyszin.kozpont) {
            res[0].helyszin.kozpont = 'false';
          }

          if (res[0].helyszin.leiras)
            this.setState({ leiras: res[0].helyszin.leiras ? res[0].helyszin.leiras : '', });
          if (res[0].angol && res[0].helyszin.leirasangol)
            this.setState({ leirasAngol: res[0].helyszin.leirasangol ? res[0].helyszin.leirasangol : '', });

          this.setState({
            azonosito: res[0].helyszin.azonosito,
            nev: res[0].helyszin.nev,
            kozpont: res[0].helyszin.kozpont,
            allapotValue: res[0].helyszin.allapot && res[0].helyszin.allapot.name,
            tipusValue: res[0].helyszin.tipus && res[0].helyszin.tipus.name,
            cegadatValue: res[0].helyszin.cegadat,

            orszagValue: { orszagid: res[0].helyszin.orszagid, nev: res[0].helyszin.orszagnev },
            dataLoaded: true,
            telepulesSelect: res[0].helyszin.orszag && res[0].helyszin.orszag.nev && res[0].helyszin.orszag.nev.toUpperCase() === 'MAGYARORSZÁG',
            telepulesMezoInaktiv: false,

            kozterulet: this.nullToString(res[0].helyszin.kozterulet),
            kozteruletjelleg: this.nullToString(res[0].helyszin.kozteruletjelleg),
            hrsz: this.nullToString(res[0].helyszin.hrsz),
            hazszam: this.nullToString(res[0].helyszin.hazszam),
            lepcsohaz: this.nullToString(res[0].helyszin.lepcsohaz),
            epulet: this.nullToString(res[0].helyszin.epulet),
            emelet: this.nullToString(res[0].helyszin.emelet),
            ajto: this.nullToString(res[0].helyszin.ajto),
            postafiok: this.nullToString(res[0].helyszin.postafiok),
            cimSwitchActive: !res[0].helyszin.postafiok,
            formTelepulesNev: this.nullToString(res[0].helyszin.telepules),
            formIranyitoszamNev: this.nullToString(res[0].helyszin.irsz),
            formOrszag: {
              keresheto: this.nullToString(res[0].helyszin.keresheto),
              nev: this.nullToString(res[0].helyszin.orszag),
              orszagid: this.nullToString(res[0].helyszin.orszagid),
            },
            formKereses: {
              iranyitoszam: this.nullToString(res[0].helyszin.irsz),
              irszid: this.nullToString(res[0].helyszin.irszid),
              nev: this.nullToString(res[0].helyszin.telepules),
              telepulesid: this.nullToString(res[0].helyszin.telepulesid),
              telepulesnev: res[0].helyszin.telepules && res[0].helyszin.irsz ? this.nullToString(res[0].helyszin.telepules + ' (' + res[0].helyszin.irsz + ')') : '',
            },

            telefon: res[0].helyszin.telefon,
            email: res[0].helyszin.email,
            honlap: res[0].helyszin.honlap,
            adatvedelmiurl: res[0].helyszin.adatvedelmiurl,

            mezoJson: res[0].helyszin.metaadatok,
            formProfil: res[0].helyszin.objects !== null ? res[0].helyszin.objects.find(eObj => eObj.type.name === 'PROFIL') : null,
            formLogo: res[0].helyszin.objects !== null ? res[0].helyszin.objects.find(eObj => eObj.type.name === 'LOGO') : null,
            formGaleria: res[0].helyszin.objects !== null ? res[0].helyszin.objects.filter(eObj => eObj.type.name === 'GALERIA') : null,
          });
        }

        this.setState(prevState => ({
          angolNyelv: res[0].angol,
          allapotok: res[0].allapot.map(e => <option key={e.name} value={e.name}>{e.caption}</option>),
          tipusok: res[0].tipus.map(e => <option key={e.name} value={e.name}>{e.caption}</option>),
          tipusValue:  id ? prevState.tipusValue : 'SAJAT',
          funkcioid: res[0].funkcioid,
          loading: false,
          id: id,
          cim: 'Helyszín ' + (id ? 'módosítás' : 'felvitel'),
        }));
      }
    });
  }

  loadCegadatOptions = (input, callback) => {
    Services.listAktivCegadat(null, (err, res) => {
      if (!err) {
        callback(res[0]);
      }
    });
  }

  loadOrszagOptions = (input, callback) => {
    if (input.length !== 0) {
      Services.listOrszag(input, (err, res) => {
        if (!err) {
          callback(res[0]);
        }
      });
    }
  }

  loadKeresesOptions = (input, callback) => {
    if (input.length !== 0) {
      Services.listCim(input, (err, res) => {
        if (!err) {
          let options = [];
          res[0].forEach((item) => {
            item.telepuirszek.forEach((iranyitoszam) => {
              options.push({
                telepulesnev: item.telepulesnev + ' (' + iranyitoszam.iranyitoszam + ')',
                telepulesid: item.telepulesid,
                iranyitoszam: iranyitoszam.iranyitoszam,
                irszid: iranyitoszam.telepuirszid,
                nev: item.telepulesnev,
                // irsz:
              });
            });
          });
          callback(options);
        }
      });
    }
  }

  nullToString = (data) => {
    if (!data) return '';
    return data;
  }

  toggleCimSwitch = (trueFalse) => {
    if (trueFalse !== this.state.cimSwitchActive) {
      this.setState(prevState => ({
        cimSwitchActive: !prevState.cimSwitchActive,
        // rem-elve, hogy cím/postafiók váltáskor ne tűnjön el a mező(k)ből az érték!, mentes()-ben kezelve! MG
        // postafiok: '',
        // kozterulet: '',
        // kozteruletjelleg: '',
        // hrsz: '',
        // hazszam: '',
        // lepcsohaz: '',
        // epulet: '',
        // emelet: '',
        // ajto: ''
      }));
    }
  }

  handleAllapotChange = (event, value) => {
    this.setState({ allapotValue: value });
  }

  handleTipusChange = (event, value) => {
    this.setState(prevState => ({ tipusValue: value, cegadatValue: value !== 'SAJAT' ? '' : prevState.cegadatValue }));
  }

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value
    });
  }

  handleChangeOrszagInput = (value) => {
    if (value && value !== '') {
      this.setState({
        formOrszag: value,
        formKereses: '',
        formIranyitoszamNev: '',
        formTelepulesNev: ''
      });
    } else {
      this.setState({
        formOrszag: '',
        formKereses: '',
        formIranyitoszamNev: '',
        formTelepulesNev: ''
      });
    }
  }

  handleChangeKeresesInput = (value) => {
    if (value && value !== '') {
      this.setState({
        formKereses: value,
        formTelepulesNev: value.nev,
        formIranyitoszamNev: value.iranyitoszam
      });
    } else {
      this.setState({
        formKereses: '',
        formTelepulesNev: '',
        formIranyitoszamNev: ''
      });
    }
  }

  handleChangeSelect = (v, name) => {
    const value = v === '' ? null : v;
    this.setState({
      [name]: value
    });
  }

  onDropProfil = (acceptedfiles) => {
    acceptedfiles.forEach((file) => {
      const reader = new FileReader();
      reader.onload = () => {
        const fileAsBinaryString = reader.result;
        let files = this.state.formProfil || [];
        files.push({
          content: btoa(fileAsBinaryString),
          uploadDate: new Date(),
          docname: file.name,
          type: 'PROFIL',
          preview: file.preview,
          logo: false,
          mime: file.type || 'application/octet-stream',
          new: true,
          length: file.size,
          // id: Lib.Browser.uuidv4(),
        });
        this.setState({ formProfil: files[0] });
      };
      reader.readAsBinaryString(file);
    });
  }

  onDropLogo = (acceptedfiles) => {
    acceptedfiles.forEach((file) => {
      const reader = new FileReader();
      reader.onload = () => {
        const fileAsBinaryString = reader.result;
        let files = this.state.formLogo || [];
        files.push({
          content: btoa(fileAsBinaryString),
          uploadDate: new Date(),
          docname: file.name,
          type: 'LOGO',
          preview: file.preview,
          logo: false,
          mime: file.type || 'application/octet-stream',
          new: true,
          length: file.size,
          // id: Lib.Browser.uuidv4(),
        });
        this.setState({ formLogo: files[0] });
      };
      reader.readAsBinaryString(file);
    });
  }

  onDropGaleria = (acceptedfiles) => {
    acceptedfiles.forEach((file) => {
      const reader = new FileReader();
      reader.onload = () => {
        const fileAsBinaryString = reader.result;
        let files = this.state.formGaleria || [];
        files.push({
          content: btoa(fileAsBinaryString),
          uploadDate: new Date(),
          docname: file.name,
          type: 'GALERIA',
          preview: file.preview,
          logo: false,
          mime: file.type || 'application/octet-stream',
          new: true,
          length: file.size,
          // id: Lib.Browser.uuidv4(),
        });
        this.setState({ formGaleria: files });
      };
      reader.readAsBinaryString(file);
    });
  }

  renderAngolValaszto = () => {
    return (
      <div className="col-md-12" style={{ textAlign: 'center' }}>
        <SwitchButton
          active={this.state.magyarSwitchButton}
          trueLabel="Magyar"
          trueToggle={() => this.setState({ magyarSwitchButton: true })}
          trueWidth={100}
          falseToggle={() => this.setState({ magyarSwitchButton: false })}
          falseLabel="Angol"
          falseWidth={100}
        />
      </div>
    );
  }

  renderAlapAdatok = () => {
    let titleStyle = {
      marginBottom: 20,
      marginTop: 10
    };
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <div>
              <h5 style={titleStyle}>
                {'Alapadatok:'}
              </h5>
            </div>
          </div>
          <div className="col-md-2">
            <RFField
              name="azonosito"
              id="azonosito"
              label="Helyszín azonosító: *"
              value={this.state.azonosito}
              onChange={this.handleInputChange}
              disabled={this.props.modositas}
              maxLength={10}
              errorMessage="Kötelező mező!"
              // validate={{
              //   maxLength: { value: 10 }
              // }}
              required
            />
          </div>
          <div className="col-md-2">
            <RFField
              name="nev"
              id="nev"
              label="Helyszín név: *"
              value={this.state.nev}
              onChange={this.handleInputChange}
              errorMessage="Kötelező mező!"
              maxLength={50}
              // validate={{
              //   maxLength: { value: 50 }
              // }}
              required
            />
          </div>
          <div className="col-md-2">
            <RFField
              type="select"
              name="kozpont"
              id="kozpont"
              label="Központ: *"
              defaultValue={null}
              disabled={this.props.modositas}
              value={this.state.kozpont}
              onChange={this.handleInputChange}
              errorMessage="Kötelező mező!"
              required
              defaultSelect={<option key="null" value={null}>Válassz opciót...</option>}
              selectOptions={
                <React.Fragment>
                  <option key="true" value="true">Igen</option>
                  <option key="false" value="false">Nem</option>
                </React.Fragment>
              }
            />
          </div>
          <div className="col-md-2">
            <RFField
              type="select"
              name="allapot"
              id="allapot"
              label="Állapot: *"
              defaultValue={null}
              value={this.state.allapotValue}
              onChange={this.handleAllapotChange}
              errorMessage="Kötelező mező!"
              required
              defaultSelect={<option key="null" value={''}>Válassz opciót...</option>}
              selectOptions={this.state.allapotok}
            />
          </div>
          <div className="col-md-2">
            <RFField
              type="select"
              name="tipus"
              id="tipus"
              label="Helyszín típus: *"
              defaultValue={null}
              value={this.state.tipusValue}
              onChange={this.handleTipusChange}
              errorMessage="Kötelező mező!"
              required
              defaultSelect={<option key="null" value={''}>Válassz opciót...</option>}
              selectOptions={this.state.tipusok}
            />
          </div>
          <div className="col-md-2">
            <Label for="cegadat">
              {'Cégadat:' + (this.state.tipusValue === 'SAJAT' ? ' *' : '')}
            </Label>
            <Select
              styles={{
                control: base => ({
                  ...base,
                  '&:focus': { borderColor: 'red' },
                  border: '1px solid lightgray',
                  boxShadow: 'none',
                  borderRadius: '0'
                }),
              }}
              name="cegadat"
              id="cegadat"
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              searchPromptText="Kezdj el gépelni a kereséshez..."
              loadingMessage={() => 'Keresés...'}
              onChange={v => this.handleChangeSelect(v, 'cegadatValue')}
              isClearable
              ignoreAccents={false}
              loadOptions={_.debounce(this.loadCegadatOptions, 1000)}
              isLoading={false}
              getOptionLabel={option => option.nev + (option.tipus ? ' (' + option.tipus + ')' : '')}
              getOptionValue={option => option.id}
              value={this.state.cegadatValue}
              cache={false}
              defaultOptions
              required={this.state.tipusValue === 'SAJAT'}
              isDisabled={this.state.tipusValue !== 'SAJAT'}
            />
          </div>
        </div>
      </div>
    );
  }

  renderEgyebAdatok = () => {
    let titleStyle = {
      marginBottom: 20,
      marginTop: 10
    };
    return (
      <div>
        <div className="row">
          <div className="col-md-3">
            <div>
              <h5 style={titleStyle}>
                {'Cím:'}
              </h5>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3" style={{ marginBottom: '1rem' }}>
            <SelectField
              variant='async'
              label='Ország:'
              name="formOrszag"
              id="formOrszag"
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              searchPromptText="Kezdj el gépelni a kereséshez..."
              loadingMessage={() => 'Keresés...'}
              onChange={v => this.handleChangeOrszagInput(v)}
              clearable
              ignoreAccents={false}
              loadOptions={_.debounce(this.loadOrszagOptions, 1000)}
              isLoading={false}
              getOptionLabel={option => option.nev}
              getOptionValue={option => option.orszagid}
              value={this.state.formOrszag}
              cache={false}
              autoload={false}
              required
            />
          </div>
          {this.state.formOrszag && this.state.formOrszag.keresheto && (
            <div className="col-md-3" style={{ marginBottom: '1rem' }}>
              <Label for="formKereses">Keresés: </Label>
              <Select
                styles={{
                  control: base => ({
                    ...base,
                    '&:focus': { borderColor: 'red' }, // border style on hover
                    border: '1px solid lightgray', // default border color
                    boxShadow: 'none', // no box-shadow
                    borderRadius: '0'
                  }),
                }}
                name="formKereses"
                id="formKereses"
                placeholder="Település vagy irányítószám"
                noOptionsMessage={() => 'Nincs keresési eredmény'}
                searchPromptText="Kezdj el gépelni a kereséshez..."
                loadingMessage={() => 'Keresés...'}
                onChange={v => this.handleChangeKeresesInput(v)}
                // isClearable
                ignoreAccents={false}
                // loadOptions={(input, callback) => this.loadKeresesOptions(input, callback)}
                loadOptions={_.debounce(this.loadKeresesOptions, 1000)}
                getOptionLabel={option => option.telepulesnev}
                getOptionValue={option => option.telepulesid}
                isLoading={false}
                value={this.state.formKereses}
                cache={false}
                autoload={false}
              />
            </div>
          )}
          <div className="col-md-3">
              <RFField
                label={'Irányítószám: *'}
                name="formIranyitoszamNev"
                id="formIranyitoszamNev"
                type="text"
                maxLength="20"
                value={this.state.formIranyitoszamNev}
                onChange={this.handleInputChange}
                disabled={(this.state.formOrszag && this.state.formOrszag.keresheto) || (this.state.formOrszag === '')}
                required
              />
          </div>
          <div className="col-md-3">
              <RFField
                label={'Település: *'}
                name="formTelepulesNev"
                id="formTelepulesNev"
                type="text"
                value={this.state.formTelepulesNev}
                onChange={this.handleInputChange}
                disabled={(this.state.formOrszag && this.state.formOrszag.keresheto) || (this.state.formOrszag === '')}
                required
              />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <SwitchButton
              active={this.state.cimSwitchActive}
              trueToggle={() => this.toggleCimSwitch(true)}
              falseToggle={() => this.toggleCimSwitch(false)}
              style={{ marginBottom: 15, marginTop: 8 }}
              trueLabel="Cím"
              falseLabel="Postafiók"
            />
          </div>
        </div>
        {this.state.cimSwitchActive && (
          <React.Fragment>
            <div className="row">
              <div className="col-md-3">
                  <RFField
                    label={'Közterület neve: *'}
                    name="kozterulet"
                    id="kozterulet"
                    type="text"
                    value={this.state.kozterulet}
                    onChange={this.handleInputChange}
                    maxLength="50"
                    required
                  />
              </div>
              <div className="col-md-3">
                  <RFField
                    label={'Közterület jellege: *'}
                    name="kozteruletjelleg"
                    id="kozteruletjelleg"
                    value={this.state.kozteruletjelleg}
                    onChange={this.handleInputChange}
                    type="text"
                    maxLength="20"
                    required
                  />
              </div>
              <div className="col-md-3">
                  <RFField
                    label={'Házszám:'}
                    name="hazszam"
                    id="hazszam"
                    value={this.state.hazszam}
                    onChange={this.handleInputChange}
                    type="text"
                    maxLength="20"
                  />
              </div>
              <div className="col-md-3">
                  <RFField
                    label={'Hrsz:'}
                    name="hrsz"
                    id="hrsz"
                    value={this.state.hrsz}
                    onChange={this.handleInputChange}
                    type="text"
                    maxLength="20"
                  />
              </div>
            </div>
            <div className="row">
              <div className="col-md-3">
                  <RFField
                    label={'Épület:'}
                    name="epulet"
                    id="epulet"
                    value={this.state.epulet}
                    onChange={this.handleInputChange}
                    type="text"
                    maxLength="4"
                  />
              </div>
              <div className="col-md-3">
                  <RFField
                    label={'Lépcsőház: '}
                    name="lepcsohaz"
                    id="lepcsohaz"
                    value={this.state.lepcsohaz}
                    onChange={this.handleInputChange}
                    type="text"
                    maxLength="4"
                  />
              </div>
              <div className="col-md-3">
                  <RFField
                    label={'Emelet:'}
                    name="emelet"
                    id="emelet"
                    value={this.state.emelet}
                    onChange={this.handleInputChange}
                    type="text"
                    maxLength="10"
                  />
              </div>
              <div className="col-md-3">
                  <RFField
                    label={'Ajtó:'}
                    name="ajto"
                    id="ajto"
                    value={this.state.ajto}
                    onChange={this.handleInputChange}
                    type="text"
                    maxLength="15"
                  />
              </div>
            </div>
          </React.Fragment>
        )}
        {!this.state.cimSwitchActive && (
          <div className="row">
            <div className="col-md-3">
                <RFField
                  label={'Postafiók: *'}
                  name="postafiok"
                  id="postafiok"
                  value={this.state.postafiok}
                  onChange={this.handleInputChange}
                  required
                  type="text"
                  maxLength="40"
                />
            </div>
          </div>
        )}
        <div className="row">
          <div className="col-md-12">
            <div>
              <h5 style={titleStyle}>
                Elérhetőségek:
              </h5>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3">
            <RFField
              label={'Telefonszám:'}
              name="telefon"
              id="telefon"
              value={this.state.telefon}
              onChange={this.handleInputChange}
              maxLength={100}
              // validate={{
              //   maxLength: { value: 100 }
              // }}
            />
          </div>
          <div className="col-md-3">
            <RFField
              label={'Email:'}
              name="email"
              id="email"
              value={this.state.email}
              onChange={this.handleInputChange}
              maxLength={100}
              // validate={{
              //   maxLength: { value: 100 }
              // }}
            />
          </div>
          <div className="col-md-3">
            <RFField
              label={'Weboldal:'}
              name="honlap"
              id="honlap"
              value={this.state.honlap}
              onChange={this.handleInputChange}
              maxLength={100}
              // validate={{
              //   maxLength: { value: 100 }
              // }}
            />
          </div>
          <div className="col-md-3">
            <RFField
              label={'Adatvédelmi tájékoztató:'}
              name="adatvedelmiurl"
              id="adatvedelmiurl"
              value={this.state.adatvedelmiurl}
              onChange={this.handleInputChange}
              maxLength={100}
              // validate={{
              //   maxLength: { value: 100 }
              // }}
            />
          </div>
        </div>
      </div>
    );
  }

  renderFormButtons = () => {
    return (
      <div className="row">
        <div className="col-md-12">
          <ProgressButton
            color="primary"
            loading={this.state.mentesButtonLoading}
          >
            Mentés
          </ProgressButton>
          {' '}
          <Button type="button" color="secondary" onClick={this.handleFormCancelClick}>
            Mégsem
          </Button>
        </div>
      </div>
    );
  }

  onChange = (value, angol) => {
    let obj = {};
    if (angol)
      obj.leirasAngol = value;
    else
      obj.leiras = value;
    this.setState(obj);
  };

  toggleNested = () => {
    this.setState({
      nestedModal: !this.state.nestedModal
    });
  }

  toggleProfilModal = () => {
    this.setState(prevState => ({ profilModal: !prevState.profilModal }));
  }

  toggleLogoModal = () => {
    this.setState(prevState => ({ logoModal: !prevState.logoModal }));
  }

  toggleGaleriaModal = (idx) => {
    this.setState(prevState => ({ galeriaModal: !prevState.galeriaModal, galeriaIndex: idx }));
  }

  updateMetaadat = (event, mezonev) => {
    this.state.mezoJson[mezonev] = event.target.value;
  }

  deleteMetaadat = (mezonev) => {
    delete this.state.mezoJson[mezonev];
    this.setState({ mezoJson: this.state.mezoJson });
  }

  renderMezok = () => {
    let mezok = [];
    let idx = 0;
    for (let mezonev in this.state.mezoJson) {
      mezok.push(<Mezo mezonev={mezonev} tartalom={this.state.mezoJson[mezonev]} updateMeta={e => this.updateMetaadat(e, mezonev)} key={idx} delete={this.deleteMetaadat} />);
      idx++;
    }
    return mezok;
  }

  listImages = (callback) => {
    Services.listEditorImages((err, res) => {
      if (!err) {
        callback(typeof res === "object" ? res[0] : []);
      }
    });
  }

  getCurrentId = () => {
    const params = new URL(window.location.href).searchParams;
    return params.get('id');
  }

  addImage = async (file) => {
    const { url } = await parseEditorImage((cb) => Services.uploadEditorImage(file, this.getCurrentId() || this.state.funkcioid || undefined, cb));
    this.setState(prev => ({ deletedImages: prev.deletedImages.filter(x => x !== url) }));
    return url;
  }

  handleFormCancelClick = () => {
    if(this.state.funkcioid) {
      Services.deleteEditorImages(this.state.funkcioid, () => {});
    }
    this.setState({ funkcioid: null, deletedImages: [] });
    this.navToList();
  }

  removeImage = (node) => {
    const src = node.attrs.src;
    if(src?.startsWith('data:')) return;
    this.setState(prev => ({ deletedImages: [...prev.deletedImages, src] }));
  }

  leirasAngol = (titleStyle) => {
    return this.leiras(titleStyle, true);
  }

  leiras = (titleStyle, angol) => {
    const { leiras, leirasAngol } = this.state;
    let classname = angol ? 'col-md-12' : 'col-md-8';
    return (
      <div className={classname} style={{ marginBottom: 15 }}>
        <div>
          <h5 style={titleStyle}>
            {angol ? 'Angol leírás:' : 'Leírás:'}
          </h5>
        </div>
        <div>
          <Wysiwyg
            value={angol ? leirasAngol : leiras}
            onChange={(value) => this.onChange(value, angol)}
            onImageUpload={this.addImage}
            onImageRemove={this.removeImage}
            toolbar={() => <ToolbarBase />}
          />
        </div>
      </div>
    );
  }

  renderExtrak = () => {
    let titleStyle = {
      marginBottom: 20,
      marginTop: 10
    };
    return (
      <div>
        <div className="row">
          <div className="col-md-12" hidden={!this.state.magyarSwitchButton}>
            <div>
              <h5 style={titleStyle}>
                Kiegészítő adatok:
              </h5>
            </div>
          </div>
          <div className="col-md-12 row" hidden={!this.state.magyarSwitchButton}>
            {this.renderMezok()}
          </div>
          <div className="col-md-12 row">
            <div className="col-md-3" hidden={!this.state.magyarSwitchButton}>
              <Button type="button" id="UjMezo" className="btn-cursor-pointer" color="success" onClick={this.toggleNested}>Új mező</Button>
              <UncontrolledTooltip trigger='hover focus-visible' placement="right" target="UjMezo">
                Új mező, jellemző hozzáadása a helyszínhez.
              </UncontrolledTooltip>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-2" style={{ paddingTop: 10 }} hidden={!this.state.magyarSwitchButton}>
            <Label>Profilkép: *</Label>
            {!this.state.formProfil
              && (
                <DropZone id="formProfil" onDrop={this.onDropProfil} className="custom-dropzone" accept="image/*">
                {({getRootProps, getInputProps}) => (
                    <div {...getRootProps({ className: 'custom-dropzone'})}>
                      <input {...getInputProps()} />
                      <div className="dropzone-text">
                        {'Kép feltöltése!'}
                      </div>
                    </div>
                )}
                {/* <div className="dropzone-text">
                  {'Kép feltöltése!'}
                </div> */}
              </DropZone>
                // <DropZone id="formProfil" onDrop={this.onDropProfil} className="custom-dropzone" accept="image/*">
                //   <div className="dropzone-text">
                //     {'Kép feltöltése!'}
                //   </div>
                // </DropZone>
              )
            }
            {this.state.formProfil
              && (
                <ImageCard
                  mime={this.state.formProfil.mime}
                  content={this.state.formProfil.content}
                  src={this.state.formProfil.src}
                  poster
                  onViewClick={this.toggleProfilModal}
                  onDeleteClick={() => { this.setState({ formProfil: null }); }}
                />
              )
            }
          </div>
          <div className="col-md-2" style={{ paddingTop: 10 }} hidden={!this.state.magyarSwitchButton}>
            <Label>Logo:</Label>
            {!this.state.formLogo
              && (
                <DropZone id="formLogo" onDrop={this.onDropLogo} className="custom-dropzone" accept="image/*">
                {({getRootProps, getInputProps}) => (
                    <div {...getRootProps({ className: 'custom-dropzone'})}>
                      <input {...getInputProps()} />
                      <div className="dropzone-text">
                        {'Kép feltöltése!'}
                      </div>
                    </div>
                )}
                {/* <div className="dropzone-text">
                  {'Kép feltöltése!'}
                </div> */}
              </DropZone>
                // <DropZone id="formLogo" onDrop={this.onDropLogo} className="custom-dropzone" accept="image/*">
                //   <div className="dropzone-text">
                //     {'Kép feltöltése!'}
                //   </div>
                // </DropZone>
              )
            }
            {this.state.formLogo
              && (
                <ImageCard
                  mime={this.state.formLogo.mime}
                  content={this.state.formLogo.content}
                  src={this.state.formLogo.src}
                  poster
                  onViewClick={this.toggleLogoModal}
                  onDeleteClick={() => { this.setState({ formLogo: null }); }}
                />
              )
            }
          </div>
          {this.state.magyarSwitchButton == false ? this.leiras(titleStyle, true) : this.leiras(titleStyle)}
          <div className="col-md-12" style={{ paddingLeft: '0px', paddingRight: '0px' }} hidden={!this.state.magyarSwitchButton}>
            <div className="col-md-12">
              <Label>Galéria:</Label>
              <DropZone multiple onDrop={this.onDropGaleria} className="custom-dropzone" accept="image/*">
                {({getRootProps, getInputProps}) => (
                    <div {...getRootProps({ className: 'custom-dropzone'})}>
                      <input {...getInputProps()} />
                      <div className="dropzone-text">
                        {'Kép feltöltése!'}
                      </div>
                    </div>
                )}
                {/* <div className="dropzone-text">
                  {'Kép feltöltése!'}
                </div> */}
              </DropZone>
              {/* <DropZone multiple onDrop={this.onDropGaleria} className="custom-dropzone" style={{ height: '50px' }}>
                <div className="dropzone-text">
                  {'Kép feltöltése!'}
                </div>
              </DropZone> */}
            </div>
            {this.state.formGaleria && this.state.formGaleria.map((item, idx) => {
              return (
                <div className="col-md-3" key={idx.toString()}>
                  <ImageCard
                    key={idx.toString()}
                    mime={item.mime}
                    title={item.title}
                    content={item.content}
                    main={item.main}
                    src={item.src}
                    style={{ height: '200px' }}
                    onViewClick={e => this.toggleGaleriaModal(idx)}
                    onMainImageClick={(e) => {
                      this.state.formGaleria.forEach((jk, idx2) => {
                        if (idx === idx2) {
                          jk.main = true;
                        } else {
                          jk.main = false;
                        }
                      });
                      this.setState(this.state.formGaleria);
                    }}
                    onDeleteClick={e => this.setState(prevState => ({ formGaleria: prevState.formGaleria.filter(j => j.docname != item.docname) }))}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }

  navToList = () => {
    this.props.globals.route.navigate(this.props.globals.public_url.concat('/admin/torzsadatok/helyszin'));
  }

  emptyToNull = (obj) => {
    if (!obj || typeof obj !== 'object') return;
    for (let p in obj) {
      if (typeof obj[p] === 'object' && obj[p] !== null) {
        this.emptyToNull(obj[p]);
      } else if (obj.hasOwnProperty(p)) {
        if (obj[p] === '' || obj[p] === undefined) {
          obj[p] = null;
        }
      }
    }
  }

  emptyOrNull = (data) => {
    if (!data || data === '') return null;
    return data;
  }

  mentes = (event, helyszinObj) => {
    let submitObj = { ...helyszinObj };
    let objects = [];
    if (this.state.formProfil) {
      objects.push(this.state.formProfil);
    }
    if (this.state.formLogo) {
      objects.push(this.state.formLogo);
    }
    if (this.state.formGaleria) {
      this.state.formGaleria.forEach(j => objects.push(j));
    }

    // submitObj.azonosito = this.emptyOrNull(this.state.azonosito);
    // submitObj.nev = this.emptyOrNull(this.state.nev);
    submitObj.kozpont = this.state.kozpont;
    // submitObj.allapot = this.state.allapotValue && this.state.allapotValue === 'Válassz opciót...' ? null : this.state.allapotValue;

    submitObj.cegadatid = this.state.cegadatValue ? this.state.cegadatValue.id : null;
    submitObj.orszagid = this.state.formOrszag ? this.state.formOrszag.orszagid : null;

    if (this.state.formOrszag && this.state.formOrszag.keresheto) {
      submitObj.telepulesid = this.emptyOrNull(this.state.formKereses.telepulesid);
      submitObj.irszid = this.emptyOrNull(this.state.formKereses.irszid);
    } else {
      submitObj.telepules = this.emptyOrNull(this.state.formTelepulesNev);
      submitObj.irsz = this.emptyOrNull(this.state.formIranyitoszamNev);
    }

    if (this.state.cimSwitchActive) { // cím
      // submitObj.kozterulet = this.state.kozterulet;
      // submitObj.kozteruletjelleg = this.state.kozteruletjelleg;
      // submitObj.hazszam = this.state.hazszam;
      // submitObj.hrsz = this.state.hrsz;
      // submitObj.lepcsohaz = this.state.lepcsohaz;
      // submitObj.epulet = this.state.epulet;
      // submitObj.emelet = this.state.emelet;
      // submitObj.ajto = this.state.ajto;

      submitObj.postafiok = null;
    } else { // postafiók
      // submitObj.postafiok = this.state.postafiok;

      submitObj.kozterulet = null;
      submitObj.kozteruletjelleg = null;
      submitObj.hazszam = null;
      submitObj.hrsz = null;
      submitObj.lepcsohaz = null;
      submitObj.epulet = null;
      submitObj.emelet = null;
      submitObj.ajto = null;
    }

    // submitObj.telefon = this.state.telefon;
    // submitObj.email = this.state.email;
    // submitObj.honlap = this.state.honlap;
    // submitObj.adatvedelmiurl = this.state.adatvedelmiurl;

    submitObj.metaadatok = this.state.mezoJson;

    submitObj.objects = objects.map((o) => {
      return Object.assign(o || {}, { type: o ? typeof o.type === 'string' ? o.type : o.type.name : null });
    });
    if (submitObj.kozpont === 'Válassz opciót...') {
      this.props.globals.addError('Központ választása kötelező!');
    } else {
      this.setState({ mentesButtonLoading: true });
      submitObj.kozpont = submitObj.kozpont === 'Válassz opciót...' ? null : submitObj.kozpont;
      submitObj.leiras = this.state.leiras;

      if (this.state.angolNyelv == true) {
        submitObj.leirasangol = this.state.leirasAngol;
      }

      this.emptyToNull(submitObj);
      if (this.props.modositas) {
        submitObj.id = this.state.id;
        Services.modifyHelyszin(submitObj, (err) => {
          this.setState({ mentesButtonLoading: false });
          if (!err) {
            this.props.globals.addSuccess('Helyszín módosítva!');
            this.navToList();
          }
        });
      } else {
        submitObj.funkcioid = this.state.funkcioid,
        Services.addHelyszin(submitObj, (err) => {
          this.setState({ mentesButtonLoading: false });
          if (!err) {
            this.props.globals.addSuccess('Helyszín hozzáadva!');
            this.navToList();
          }
        });
      }
    }

    if(this.state.funkcioid) {
      for(const src of this.state.deletedImages) {
        Services.deleteEditorImage(this.state.funkcioid, src.split('/').at(-1), () => {});
      }
    }
  }

  addMezo = (event, mezoObj) => {
    let ujObj = {};
    ujObj[mezoObj.mezonev] = mezoObj.tartalom;
    this.setState({ mezoJson: Object.assign(this.state.mezoJson, ujObj) });
    this.toggleNested();
  }

  render() {
    let cardStyle = {
      padding: 20
    };
    let titleStyle = {
      marginBottom: 20,
      marginTop: 20
    };
    return (
      <div>
        <div className="animated fadeIn">
          <div className="card">
            <div className="card-header">
              {this.state.cim}
            </div>
            <div style={cardStyle}>
              {this.state.loading
                ? <Loader />
                : (
                  <RFForm onSubmit={this.mentes}>
                    {this.state.angolNyelv == true ? this.renderAngolValaszto() : ''}
                    {this.state.magyarSwitchButton == true
                      && (
                        <div>
                          {this.renderAlapAdatok()}
                          {this.renderEgyebAdatok()}
                        </div>
                      )
                    }
                    {this.renderExtrak()}
                    {this.renderFormButtons()}
                  </RFForm>
                )
              }
            </div>
          </div>
        </div>
        {/* <Modal isOpen={this.state.nestedModal} toggle={this.toggleNested} backdrop="static"> */}
          <RFForm
            onSubmit={this.addMezo}
            modalInsert
            title={'Új helyszín jellemző felvétel'}
            tagProps={{ isOpen: this.state.nestedModal, toggle: this.toggleNested, backdrop: 'static' }}
            footer={
              <React.Fragment>
                <Button color="primary" type='submit'>Hozzáadás</Button>
                {' '}
                <Button type="button" color="secondary" onClick={this.toggleNested}>Mégsem</Button>
              </React.Fragment>
            }
          >
                <RFField label={'Mező neve: *'} name="mezonev" id="mezonev" regex={[/[^\d]/g, "A mező nem tartalmazhat csak számot!"]} required />
                <RFField label={'Mező tartalma: *'} name="tartalom" id="tartalom" required />
          </RFForm>
            <RFForm
              onSubmit={() => {}}
              modalInsert
              title={''}
              tagProps={{ isOpen: this.state.profilModal, toggle: this.toggleProfilModal, backdrop: 'static' }}
              footer={
                <Button className="btn-cursor-pointer pull-right" color="secondary" onClick={this.toggleProfilModal}>
                  OK
                </Button>
              }
            >
              <Card style={{ marginBottom: '0', border: 'none' }}>
                {this.state.formProfil
                  && (
                    <React.Fragment>
                      <CardImg
                        src={this.state.formProfil.src ? this.state.formProfil.src : 'data:image/bmp;base64,' + this.state.formProfil.content}
                        onClick={this.toggleProfilModal}
                      />
                      <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <RFField
                          // style={{height: '250px'}}
                          // className="munkalap-profil-textarea"
                          placeholder="Kép leírás..."
                          type="text"
                          onChange={(e, v) => { this.setState(prevState => ({ formProfil: { ...prevState.formProfil, alt: v } })); }}
                          value={this.state.formProfil.alt}
                          disabled={this.state.formProfil.id}
                          name="formProfilAltTag"
                          id="formProfilAltTag"
                        />
                      </div>
                    </React.Fragment>
                  )
                }
              </Card>
            </RFForm>
          <RFForm
            onSubmit={() => {}}
            modalInsert
            title={''}
            tagProps={{ isOpen: this.state.logoModal, toggle: this.toggleLogoModal, backdrop: 'static' }}
            footer={
              <Button className="btn-cursor-pointer pull-right" color="secondary" onClick={this.toggleLogoModal}>
                OK
              </Button>
            }
          >
            <Card style={{ marginBottom: '0', border: 'none' }}>
                {this.state.formLogo
                  && (
                    <React.Fragment>
                      <CardImg
                        src={this.state.formLogo.src ? this.state.formLogo.src : 'data:image/bmp;base64,' + this.state.formLogo.content}
                        onClick={this.toggleLogoModal}
                      />
                      <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <RFField
                          // style={{height: '250px'}}
                          // className="munkalap-profil-textarea"
                          placeholder="Kép leírás..."
                          type="text"
                          onChange={(e, v) => { this.setState(prevState => ({ formLogo: { ...prevState.formLogo, alt: v } })); }}
                          value={this.state.formLogo.alt}
                          disabled={this.state.formLogo.id}
                          name="formLogoAltTag"
                          id="formLogoAltTag"
                        />
                      </div>
                    </React.Fragment>
                  )
                }
            </Card>
          </RFForm>
          <RFForm
            onSubmit={() => {}}
            modalInsert
            title={''}
            tagProps={{ isOpen: this.state.galeriaModal, toggle: this.toggleGaleriaModal, backdrop: 'static' }}
            footer={
              <Button className="btn-cursor-pointer pull-right" color="secondary" onClick={this.toggleGaleriaModal}>
                OK
              </Button>
            }
          >
            <Card style={{ marginBottom: '0', border: 'none' }}>
              {this.state.formGaleria[this.state.galeriaIndex]
                && (
                  <React.Fragment>
                    <CardImg
                      src={this.state.formGaleria[this.state.galeriaIndex].src ? this.state.formGaleria[this.state.galeriaIndex].src : 'data:image/bmp;base64,' + this.state.formGaleria[this.state.galeriaIndex].content}
                      onClick={this.toggleGaleriaModal}
                    />
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      <RFField
                        className="pull-left"
                        placeholder="Kép leírás..."
                        type="text"
                        onChange={(e, v) => {
                          let formGaleria = this.state.formGaleria;
                          formGaleria.forEach((jK, idx) => {
                            if (idx == this.state.galeriaIndex) {
                              jK.alt = v;
                            }
                          });
                          this.setState(formGaleria);
                        }}
                        disabled={this.state.formGaleria[this.state.galeriaIndex].id}
                        value={this.state.formGaleria[this.state.galeriaIndex].alt}
                        name="formGaleriaAltTag"
                        id="formGaleriaAltTag"
                      />
                    </div>
                  </React.Fragment>
                )
              }
            </Card>
          </RFForm>
      </div>
    );
  }
}

export default HelyszinUrlap;
